module.exports = __webpack_public_path__ + "img/toutiao.da8b761c.png";